<script setup lang="ts">
type Links = {
  title: string
  path: string
  rel?: string
  target?: string
}

type Props = { links: Links[] }

defineProps<Props>()
</script>

<template>
  <ul class="links-list">
    <li v-for="link in links" :key="link.path">
      <nuxt-link
        class="links-list__link"
        :prefetch="false"
        :to="link.path"
        :rel="link.rel"
        :target="link.target"
      >
        {{ link.title }}
      </nuxt-link>
    </li>
  </ul>
</template>

<style scoped lang="scss">
.links-list {
  display: grid;
  gap: 14px;
  padding: 0;
  font-size: 14px;
  font-weight: 500;
  line-height: 17px;
  list-style-type: none;

  &__link {
    color: $text-grey;
  }
}
</style>
